
import $ from "jquery"
import serialize from "form-serialize"
import { EventEmitter } from "events"

import {
  SAPriceDropdown as PriceDropdown,
  Factory as PriceDropdownFactory,
} from "./price_dropdown/index"
import {
  BuyRentDesktopAreaSizeDropdown,
  Factory as AreaSizeDropdownFactory,
} from "./area_size_dropdown/index"
import {
  CategoriesSelector,
  Factory as CategoriesSelectorFactory,
} from "./categories_selector/index"
import {
  CurrencySelector,
  Factory as CurrencySelectorFactory,
} from "./currency_selector/index"
import {
  CountriesSelector,
  Factory as CountriesSelectorFactory,
} from "./countries_selector/index"
import {
  Factory as CitiesSelectorFactory,
  CitiesSelector,
} from "./cities_selector/index"

import param from "jquery-param"
import URI from "urijs"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import Modal from "app/modal/show-modal"

import BuildingsOverseasMarketingShareBox from "concepts/buildings/overseas_marketing/share/box"
import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"


interface Selector {
  main: string | JQuery
  form: string | JQuery
  countries_selector: string | JQuery
  cities_selector: string | JQuery

  share_btn: string | JQuery
  reset_btn: string | JQuery
}
export interface InputSelector {
  main?: string | JQuery
  form?: string | JQuery
  countries_selector?: string | JQuery
  cities_selector?: string | JQuery

  share_btn?: string | JQuery
  reset_btn?: string | JQuery
}
const DEFAULT_SELECTOR = {
  main:               ".cell--buildings--overseas-marketing--filter",
  form:               ".cell--buildings--overseas-marketing--filter--form",
  countries_selector: ".cell--buildings--overseas-marketing--filter--form__countries",
  cities_selector:    ".cell--buildings--overseas-marketing--filter--form__cities",

  share_btn: ".cell--buildings--overseas-marketing--filter--form-share",
  reset_btn: ".cell--buildings--overseas-marketing--filter--form-reset",
}


const FILTER_CHANGE = "with-state-filter-changed"
const INPUT_DISABLE = "with-input-disabled"


export class DesktopFilter extends EventEmitter {
  protected selector:             Selector

  protected $el:                  JQuery
  protected $countries_selector?: JQuery
  protected $cities_selector?:    JQuery

  protected $reset_btn?: JQuery
  protected $share_btn?: JQuery

  protected $form?: JQuery

  protected price_dropdown?:          PriceDropdown
  protected area_size_dropdown?:      BuyRentDesktopAreaSizeDropdown
  protected categories_selector?:     CategoriesSelector

  protected currency_selector?:   CurrencySelector
  protected cities_selector?:     CitiesSelector
  protected countries_selector?:  CountriesSelector

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$el = $(this.selector.main)

    if (! this._is_noop_mode()) {
      this.$reset_btn = this.$el.find(this.selector.reset_btn)
      this.$share_btn = this.$el.find(this.selector.share_btn)

      this.$form = this.$el.find(this.selector.form)
      this.$countries_selector = this.$el.find(this.selector.countries_selector)
      this.$cities_selector = this.$el.find(this.selector.cities_selector)

      this.price_dropdown = PriceDropdownFactory.create({scope: this.$el})
      this.area_size_dropdown = AreaSizeDropdownFactory.create({scope: this.$el})
      this.categories_selector = CategoriesSelectorFactory.create({scope: this.$el})

      this.currency_selector = CurrencySelectorFactory.create()

      if (this.$countries_selector.length > 0) {
        this.countries_selector = CountriesSelectorFactory.create({
          scope:  this.$el,
          main:   this.$countries_selector,
        })
      }

      if (this.$cities_selector.length > 0) {
        this.cities_selector = CitiesSelectorFactory.create({
          scope:  this.$el,
          main:   this.$cities_selector,
        })
      }
    }

    this.created()
    this.bind_action()
  }

  public getSelectedText(): string {
    if (this._is_noop_mode()) { return "" }
    if (this.categories_selector == null) { return "" }

    return this.categories_selector.getSelectedText()
  }
  public get_form_data(): unknown {
    if (this.$form == null) { return {} }

    return serialize((this.$form[0] as HTMLFormElement), {hash: true}) || {}
  }
  public setAsLoaded(): void {
    this.$el.removeClass(INPUT_DISABLE)
  }
  public get_form_url(): string {
    if (this.$form == null) { return "" }

    return this.$form.attr("action")
  }
  public setAsLoading(): void {
    this.$el.addClass(INPUT_DISABLE)
  }
  public getSelectedCategory(): void {
    if (this._is_noop_mode()) { return }
    if (this.categories_selector == null) { return }

    return this.categories_selector.getSelectedValue()
  }
  protected created(): void {
    this.toggleFilterStatus()
    this.togglePriceDropdown()

    if (this.countries_selector){
      this.cities_selector?.repopulate_city_options()
    }
  }
  protected bind_action(): void {
    if (this._is_noop_mode()) { return }

    if (this.price_dropdown == null) { return }
    this.price_dropdown.on("val_change", () => {
      this.toggleFilterStatus()
      this.emit("val_change")
    })
    if (this.area_size_dropdown == null) { return }
    this.area_size_dropdown.on("val_change", () => {
      this.toggleFilterStatus()
      this.emit("val_change")
    })
    if (this.categories_selector == null) { return }
    this.categories_selector.on("val_change", () => {
      this.toggleFilterStatus()
      this.emit("category_change")
    })
    if (this.$reset_btn == null) { return }
    this.$reset_btn.on("click", (e) => {
      e.preventDefault()
      this.onResetClick()
    })
    if (this.$share_btn == null) { return }
    this.$share_btn.on("click", (e) => {
      e.preventDefault()
      this.onShareClick()
    })

    this.currency_selector?.on("val_change", () => {
      this.togglePriceDropdown()
      this.toggleFilterStatus()
      this.emit("val_change")
    })

    this.cities_selector?.on("val_change", () => {
      this.toggleFilterStatus()
      this.emit("val_change")
    })

    if (this.countries_selector){
      this.countries_selector.on("val_change", () => {
        this.toggleFilterStatus()
        this.cities_selector?.repopulate_city_options(this.countries_selector?.selected_items() || [])
      })
    }
  }
  protected togglePriceDropdown(): void {
    if (this.currency_selector == null) { return }
    if (this.price_dropdown == null) { return }

    this.price_dropdown.show()
    this.price_dropdown.reset()
  }
  protected onShareClick(): unknown {
    const overseas_properties_listing_search_criteria_set_params =
    (this.get_form_data() as any).overseas_properties_listing_search_criteria_set
    Modal.showLoadingIndicator()

    if (overseas_properties_listing_search_criteria_set_params["spacious_country_slugs"]) {
      overseas_properties_listing_search_criteria_set_params["spacious_country_slugs"] = (overseas_properties_listing_search_criteria_set_params["spacious_country_slugs"]).toString()
    }
    const url_object = URI(Routes.apps_spacious_website_partials_city_level_overseas_properties_landing_page_share_modal_path())
    url_object.query(
      param({
        locale:                                          I18n.locale,
        overseas_properties_listing_search_criteria_set: overseas_properties_listing_search_criteria_set_params,
      })
    )

    return q_ajax_3({
      url:      url_object.toString(),
      method:   "GET",
      dataType: "HTML",
    })
    .then(({data}) => {
      Modal.hideTopModal()
      Modal.showModalWithContent(data)
      BuildingsOverseasMarketingShareBox.create()
    })
  }
  protected toggleFilterStatus(): void {
    if (this.count() === 0){
      this.$el.removeClass(FILTER_CHANGE)
    }
    else{
      this.$el.addClass(FILTER_CHANGE)
    }
  }
  protected count(): number {
    if (this._is_noop_mode()) { return 0 }

    let count = 0

    count += this.price_dropdown?.count() || 0
    count += this.area_size_dropdown?.count() || 0

    if (this.countries_selector && !this.countries_selector.isDefault()) {
      count += 1
    }

    if (this.cities_selector && !this.cities_selector.isDefault()) {
      count += 1
    }

    if (this.categories_selector && !this.categories_selector.isDefault()) {
      count += 1
    }

    return count
  }
  protected reset(): void {
    if (this.price_dropdown == null) { return }
    if (this.area_size_dropdown == null) { return }

    this.price_dropdown.reset()
    this.area_size_dropdown.reset()
    this.cities_selector?.reset()
    this.countries_selector?.reset()
    this.categories_selector?.reset()
  }
  protected onValChange(): void {
    this.toggleFilterStatus()
  }
  protected onResetClick(): void {
    this.reset()
    this.toggleFilterStatus()
    this.emit("val_change")
  }

  protected _is_noop_mode(): boolean {
    return this.$el.length === 0
  }
}

const Factory = {
  _instance: null as null | DesktopFilter,
  instance(selector?: InputSelector): null | DesktopFilter {
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector): DesktopFilter {
    return new DesktopFilter(selector)
  },
}

export {
  Factory,
}
